import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Home from '../views/index.vue'
import drawNotice from '../views/drawNotice.vue'
import Service from '../views/service.vue'
import trendChart from '../views/trendChart.vue'
import Using from '../views/usingTutorials.vue'
import Tool from '../views/tool.vue'
import appDown from '../views/appDown.vue'
import aboutUs from '../views/adoutUs.vue'
import map from '../views/map.vue'
import mine from '../views/mine.vue'
import course from '../views/football/course.vue'
import store from '../store/store';

Vue.use(Router)

// export default new Router({
//   routes: [
//     {
//       path: '/',
//       name: 'HelloWorld',
//       component: HelloWorld
//     }
//   ]
// })
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { breadcrumb: false },
    // meta: { requiresAuth: true }
  },
  {
    path: '/drawNotice',
    name: '开奖公告',
    component: drawNotice,
    meta: { breadcrumb: '开奖公告' },
    children: [
        {
          path: 'fcssq', // 这是父路由的默认子路由
          name:'福彩双色球',
          component:()=>import ( '@/views/lotteryDetails/fcssq.vue'),
          meta: { breadcrumb: '福彩双色球'}
        },
        {
          path: 'tcdlt',
          name:'体彩大乐透',
          component:()=>import ( '@/views/lotteryDetails/tcdlt.vue'),
          meta: { breadcrumb: '体彩大乐透'}
        },
        {
          path: 'fcsd',
          name:'福彩3D',
          component:()=>import ( '@/views/lotteryDetails/fcsd.vue'),
          meta: { breadcrumb: '福彩3D'}
        },
        {
          path: 'pls',
          name:'排列三',
          component:()=>import ( '@/views/lotteryDetails/pls.vue'),
          meta: { breadcrumb: '排列三'}
        },
        {
          path: 'qlc',
          name:'七乐彩',
          component:()=>import ( '@/views/lotteryDetails/qlc.vue'),
          meta: { breadcrumb: '七乐彩'}
        },
        {
          path: 'fiveX5',
          name:'15选5',
          component:()=>import ( '@/views/lotteryDetails/fiveX5.vue'),
          meta: { breadcrumb: '15选5'}
        },
        {
          path: 'df61',
          name:'东方6+1',
          component:()=>import ( '@/views/lotteryDetails/df61.vue'),
          meta: { breadcrumb: '东方6+1'}
        },
        {
          path: 'qxc',
          name:'七星彩',
          component:()=>import ( '@/views/lotteryDetails/qxc.vue'),
          meta: { breadcrumb: '七星彩'}
        },
        {
          path: 'plw',
          name:'排列五',
          component:()=>import ( '@/views/lotteryDetails/plw.vue'),
          meta: { breadcrumb: '排列五'}
        },
        {
          path: 'kl8',
          name:'快乐8',
          component:()=>import ( '@/views/lotteryDetails/kl8.vue'),
          meta: { breadcrumb: '快乐8'}
        },
        {
          path: 'fcLive',
          name:'福彩直播',
          component:()=>import ( '@/views/live/fcLive.vue'),
          meta: { breadcrumb: '福彩直播'}
        },
        {
          path: 'tcLive',
          name:'体彩直播',
          component:()=>import ( '@/views/live/tcLive.vue'),
          meta: { breadcrumb: '体彩直播'}
        }
    ]
  },
  {
    path: '/service',
    name: '资讯',
    component: Service,
    meta: { breadcrumb: '资讯' },
    children: [
      {
        path: 'articleDetail',
        name:'正文',
        component:()=>import ( '@/views/article/detail.vue'),
        meta: { breadcrumb: '资讯正文'}
      },
    ]
  },
  {
    path: '/trendChart',
    name: '走势图',
    component: trendChart,
    meta: { breadcrumb: '走势图' },
    children: [
      {
        path: 'ssqindex',
        name:'双色球走势',
        component:()=>import ( '@/views/trendChart/ssq/index.vue'),
        meta: { breadcrumb: '双色球走势'}
      },
      {
        path: 'ssqzs',
        name:'双色球基本',
        component:()=>import ( '@/views/trendChart/ssq/jbzs.vue'),
        meta: { breadcrumb: '双色球走势'}
      },
      {
        path: 'ssqlq',
        name:'双色球蓝球',
        component:()=>import ( '@/views/trendChart/ssq/lqzs.vue'),
        meta: { breadcrumb: '双色球走势'}
      },
      {
        path: 'ssqdw',
        name:'双色球定位',
        component:()=>import ( '@/views/trendChart/ssq/dwzs.vue'),
        meta: { breadcrumb: '双色球走势'}
      },
      {
        path: 'ssqws',
        name:'双色球尾数',
        component:()=>import ( '@/views/trendChart/ssq/wszs.vue'),
        meta: { breadcrumb: '双色球走势'}
      },
      {
        path: 'ssqdx',
        name:'双色球大小',
        component:()=>import ( '@/views/trendChart/ssq/dxzs.vue'),
        meta: { breadcrumb: '双色球走势'}
      },
      {
        path: 'ssqjo',
        name:'双色球奇偶',
        component:()=>import ( '@/views/trendChart/ssq/jozs.vue'),
        meta: { breadcrumb: '双色球走势'}
      },
      {
        path: 'ssqzh',
        name:'双色球质合',
        component:()=>import ( '@/views/trendChart/ssq/zhzs.vue'),
        meta: { breadcrumb: '双色球走势'}
      },
      {
        path: 'ssqc3',
        name:'双色球除三',
        component:()=>import ( '@/views/trendChart/ssq/csys.vue'),
        meta: { breadcrumb: '双色球走势'}
      },
      {
        path: 'ssqhz',
        name:'双色球和值',
        component:()=>import ( '@/views/trendChart/ssq/hzzs.vue'),
        meta: { breadcrumb: '双色球走势'}
      },
      {
        path: 'ssqkd',
        name:'双色球跨度',
        component:()=>import ( '@/views/trendChart/ssq/kdzs.vue'),
        meta: { breadcrumb: '双色球走势'}
      },
      {
        path: 'dltindex',
        name:'大乐透走势',
        component:()=>import ( '@/views/trendChart/dlt/index.vue'),
        meta: { breadcrumb: '大乐透走势'}
      },
      {
        path: 'dltjb',
        name:'大乐透基本',
        component:()=>import ( '@/views/trendChart/dlt/jbzs.vue'),
        meta: { breadcrumb: '大乐透走势'}
      },
      {
        path: 'dlthq',
        name:'大乐透后区',
        component:()=>import ( '@/views/trendChart/dlt/hqzs.vue'),
        meta: { breadcrumb: '大乐透走势'}
      },
      {
        path: 'dltdw',
        name:'大乐透定位',
        component:()=>import ( '@/views/trendChart/dlt/dwzs.vue'),
        meta: { breadcrumb: '大乐透走势'}
      },
      {
        path: 'dltdx',
        name:'大乐透大小',
        component:()=>import ( '@/views/trendChart/dlt/dxzs.vue'),
        meta: { breadcrumb: '大乐透走势'}
      },
      {
        path: 'dltjo',
        name:'大乐透奇偶',
        component:()=>import ( '@/views/trendChart/dlt/jozs.vue'),
        meta: { breadcrumb: '大乐透走势'}
      },
      {
        path: 'dltzh',
        name:'大乐透质合',
        component:()=>import ( '@/views/trendChart/dlt/zhzs.vue'),
        meta: { breadcrumb: '大乐透走势'}
      },
      {
        path: 'dltcs',
        name:'大乐透除3',
        component:()=>import ( '@/views/trendChart/dlt/csys.vue'),
        meta: { breadcrumb: '大乐透走势'}
      },
      {
        path: 'dlthz',
        name:'大乐透和值',
        component:()=>import ( '@/views/trendChart/dlt/hzzs.vue'),
        meta: { breadcrumb: '大乐透走势'}
      },
      {
        path: 'dltkd',
        name:'大乐透跨度',
        component:()=>import ( '@/views/trendChart/dlt/kdzs.vue'),
        meta: { breadcrumb: '大乐透走势'}
      },
      {
        path: 'dltws',
        name:'大乐透尾数',
        component:()=>import ( '@/views/trendChart/dlt/wszs.vue'),
        meta: { breadcrumb: '大乐透走势'}
      },
      {
        path: 'fcsdindex',
        name:'福彩3D走势',
        component:()=>import ( '@/views/trendChart/fcsd/index.vue'),
        meta: { breadcrumb: '福彩3D走势'}
      },
      {
        path: 'fcsdzx',
        name:'福彩3D直选',
        component:()=>import ( '@/views/trendChart/fcsd/zxzs.vue'),
        meta: { breadcrumb: '福彩3D走势'}
      },
      {
        path: 'fcsdzux',
        name:'福彩3D组选',
        component:()=>import ( '@/views/trendChart/fcsd/zuxzs.vue'),
        meta: { breadcrumb: '福彩3D走势'}
      },
      {
        path: 'fcsddx',
        name:'福彩3D大小',
        component:()=>import ( '@/views/trendChart/fcsd/dxzs.vue'),
        meta: { breadcrumb: '福彩3D走势'}
      },
      {
        path: 'fcsdjo',
        name:'福彩3D奇偶',
        component:()=>import ( '@/views/trendChart/fcsd/jozs.vue'),
        meta: { breadcrumb: '福彩3D走势'}
      },
      {
        path: 'fcsdzh',
        name:'福彩3D质合',
        component:()=>import ( '@/views/trendChart/fcsd/zhzs.vue'),
        meta: { breadcrumb: '福彩3D走势'}
      },
      {
        path: 'fcsdc3',
        name:'福彩3D除3',
        component:()=>import ( '@/views/trendChart/fcsd/csys.vue'),
        meta: { breadcrumb: '福彩3D走势'}
      },
      {
        path: 'fcsdhz',
        name:'福彩3D和值',
        component:()=>import ( '@/views/trendChart/fcsd/hzzs.vue'),
        meta: { breadcrumb: '福彩3D走势'}
      },
      {
        path: 'fcsdkd',
        name:'福彩3D跨度',
        component:()=>import ( '@/views/trendChart/fcsd/kdzs.vue'),
        meta: { breadcrumb: '福彩3D走势'}
      },
      {
        path: 'fcsddw',
        name:'福彩3D定位',
        component:()=>import ( '@/views/trendChart/fcsd/dwzs.vue'),
        meta: { breadcrumb: '福彩3D走势'}
      },
      {
        path: 'fcsdzxdw',
        name:'福彩3D组选定位',
        component:()=>import ( '@/views/trendChart/fcsd/zxdw.vue'),
        meta: { breadcrumb: '福彩3D走势'}
      },
      {
        path: 'plsindex',
        name:'排列三走势',
        component:()=>import ( '@/views/trendChart/pls/index.vue'),
        meta: { breadcrumb: '排列三走势'}
      },
      {
        path: 'plszx',
        name:'排列三直选',
        component:()=>import ( '@/views/trendChart/pls/zxzs.vue'),
        meta: { breadcrumb: '排列三走势'}
      },
      {
        path: 'plszux',
        name:'排列三组选',
        component:()=>import ( '@/views/trendChart/pls/zuxzs.vue'),
        meta: { breadcrumb: '排列三走势'}
      },
      {
        path: 'plsdx',
        name:'排列三大小',
        component:()=>import ( '@/views/trendChart/pls/dxzs.vue'),
        meta: { breadcrumb: '排列三走势'}
      },
      {
        path: 'plsjo',
        name:'排列三奇偶',
        component:()=>import ( '@/views/trendChart/pls/jozs.vue'),
        meta: { breadcrumb: '排列三走势'}
      },
      {
        path: 'plszh',
        name:'排列三质合',
        component:()=>import ( '@/views/trendChart/pls/zhzs.vue'),
        meta: { breadcrumb: '排列三走势'}
      },
      {
        path: 'plsc3',
        name:'排列三除3',
        component:()=>import ( '@/views/trendChart/pls/csys.vue'),
        meta: { breadcrumb: '排列三走势'}
      },
      {
        path: 'plshz',
        name:'排列三和值',
        component:()=>import ( '@/views/trendChart/pls/hzzs.vue'),
        meta: { breadcrumb: '排列三走势'}
      },
      {
        path: 'plskd',
        name:'排列三跨度',
        component:()=>import ( '@/views/trendChart/pls/kdzs.vue'),
        meta: { breadcrumb: '排列三走势'}
      },
      {
        path: 'plsdw',
        name:'排列三定位',
        component:()=>import ( '@/views/trendChart/pls/dwzs.vue'),
        meta: { breadcrumb: '排列三走势'}
      },
      {
        path: 'plszxdw',
        name:'排列三组选定位',
        component:()=>import ( '@/views/trendChart/pls/zxdw.vue'),
        meta: { breadcrumb: '排列三走势'}
      },
      {
        path: 'plwindex',
        name:'排列五走势',
        component:()=>import ( '@/views/trendChart/plw/index.vue'),
        meta: { breadcrumb: '排列五走势'}
      },
      {
        path: 'plwzx',
        name:'排列五直选',
        component:()=>import ( '@/views/trendChart/plw/zxzs.vue'),
        meta: { breadcrumb: '排列五走势'}
      },
      {
        path: 'plwhz',
        name:'排列五和值',
        component:()=>import ( '@/views/trendChart/plw/hzzs.vue'),
        meta: { breadcrumb: '排列五走势'}
      },
      {
        path: 'plwdxjo',
        name:'排列五大小奇偶',
        component:()=>import ( '@/views/trendChart/plw/dxjo.vue'),
        meta: { breadcrumb: '排列五走势'}
      },
      {
        path: 'plwc3',
        name:'排列五除3余数',
        component:()=>import ( '@/views/trendChart/plw/csys.vue'),
        meta: { breadcrumb: '排列五走势'}
      },
      {
        path: 'plwdw',
        name:'排列五定位',
        component:()=>import ( '@/views/trendChart/plw/dwzs.vue'),
        meta: { breadcrumb: '排列五走势'}
      },
      {
        path: 'qxcindex',
        name:'七星彩走势',
        component:()=>import ( '@/views/trendChart/qxc/index.vue'),
        meta: { breadcrumb: '七星彩走势'}
      },
      {
        path: 'qxczx',
        name:'七星彩直选',
        component:()=>import ( '@/views/trendChart/qxc/zxzs.vue'),
        meta: { breadcrumb: '七星彩走势'}
      },
      {
        path: 'qxchq',
        name:'七星彩后区',
        component:()=>import ( '@/views/trendChart/qxc/hqzs.vue'),
        meta: { breadcrumb: '七星彩走势'}
      },
      {
        path: 'qxcdx',
        name:'七星彩大小',
        component:()=>import ( '@/views/trendChart/qxc/dxzs.vue'),
        meta: { breadcrumb: '七星彩走势'}
      },
      {
        path: 'qxcjo',
        name:'七星彩奇偶',
        component:()=>import ( '@/views/trendChart/qxc/jozs.vue'),
        meta: { breadcrumb: '七星彩走势'}
      },
      {
        path: 'qxczh',
        name:'七星彩质合',
        component:()=>import ( '@/views/trendChart/qxc/zhzs.vue'),
        meta: { breadcrumb: '七星彩走势'}
      },
      {
        path: 'qxcC3',
        name:'七星彩除3',
        component:()=>import ( '@/views/trendChart/qxc/csys.vue'),
        meta: { breadcrumb: '七星彩走势'}
      },
      {
        path: 'qlcindex',
        name:'七乐彩走势',
        component:()=>import ( '@/views/trendChart/qlc/index.vue'),
        meta: { breadcrumb: '七乐彩走势'}
      },
      {
        path: 'qlcjb',
        name:'七乐彩基本',
        component:()=>import ( '@/views/trendChart/qlc/jbzs.vue'),
        meta: { breadcrumb: '七乐彩走势'}
      },
      {
        path: 'qlcdx',
        name:'七乐彩大小',
        component:()=>import ( '@/views/trendChart/qlc/dxzs.vue'),
        meta: { breadcrumb: '七乐彩走势'}
      },
      {
        path: 'qlcjo',
        name:'七乐彩奇偶',
        component:()=>import ( '@/views/trendChart/qlc/jozs.vue'),
        meta: { breadcrumb: '七乐彩走势'}
      },
      {
        path: 'qlczh',
        name:'七乐彩质合',
        component:()=>import ( '@/views/trendChart/qlc/zhzs.vue'),
        meta: { breadcrumb: '七乐彩走势'}
      },
      {
        path: 'qlcC3',
        name:'七乐彩除3',
        component:()=>import ( '@/views/trendChart/qlc/csys.vue'),
        meta: { breadcrumb: '七乐彩走势'}
      },
      {
        path: 'swxwindex',
        name:'15选5走势',
        component:()=>import ( '@/views/trendChart/swxw/index.vue'),
        meta: { breadcrumb: '15选5走势'}
      },
      {
        path: 'swxwjb',
        name:'15选5基本',
        component:()=>import ( '@/views/trendChart/swxw/jbzs.vue'),
        meta: { breadcrumb: '15选5走势'}
      },
      {
        path: 'swxwdx',
        name:'15选5大小',
        component:()=>import ( '@/views/trendChart/swxw/dxzs.vue'),
        meta: { breadcrumb: '15选5走势'}
      },
      {
        path: 'swxwjo',
        name:'15选5奇偶',
        component:()=>import ( '@/views/trendChart/swxw/jozs.vue'),
        meta: { breadcrumb: '15选5走势'}
      },
      {
        path: 'swxwzh',
        name:'15选5质合',
        component:()=>import ( '@/views/trendChart/swxw/zhzs.vue'),
        meta: { breadcrumb: '15选5走势'}
      },
      {
        path: 'swxwc3y',
        name:'15选5除3余',
        component:()=>import ( '@/views/trendChart/swxw/csys.vue'),
        meta: { breadcrumb: '15选5走势'}
      },
      {
        path: 'df61index',
        name:'东方6+1走势',
        component:()=>import ( '@/views/trendChart/df61/index.vue'),
        meta: { breadcrumb: '东方6+1走势'}
      },
      {
        path: 'df61jb',
        name:'东方6+1基本',
        component:()=>import ( '@/views/trendChart/df61/jbzs.vue'),
        meta: { breadcrumb: '东方6+1走势'}
      },
      {
        path: 'df61dx',
        name:'东方6+1大小',
        component:()=>import ( '@/views/trendChart/df61/dxzs.vue'),
        meta: { breadcrumb: '东方6+1走势'}
      },
      {
        path: 'df61jo',
        name:'东方6+1奇偶',
        component:()=>import ( '@/views/trendChart/df61/jozs.vue'),
        meta: { breadcrumb: '东方6+1走势'}
      },
      {
        path: 'df61zh',
        name:'东方6+1质合',
        component:()=>import ( '@/views/trendChart/df61/zhzs.vue'),
        meta: { breadcrumb: '东方6+1走势'}
      },
      {
        path: 'df61C3',
        name:'东方6+1除3余',
        component:()=>import ( '@/views/trendChart/df61/csys.vue'),
        meta: { breadcrumb: '东方6+1走势'}
      },
      {
        path: 'kl8index',
        name:'快乐8走势',
        component:()=>import ( '@/views/trendChart/kl8/index.vue'),
        meta: { breadcrumb: '快乐8走势'}
      },
      {
        path: 'kl8jb',
        name:'快乐8基本',
        component:()=>import ( '@/views/trendChart/kl8/jbzs.vue'),
        meta: { breadcrumb: '快乐8走势'}
      },
    ]
  },
  {
    path: '/using',
    name: '使用教程',
    component: Using,
    meta: { breadcrumb: '使用教程' },
    // meta: { requiresAuth: true }
  },
  {
    path: '/tool',
    name: '使用工具',
    component: Tool,
    meta: { breadcrumb: '使用工具' },
    // meta: { requiresAuth: true }
  },
  {
    path: '/appDown',
    name: 'App下载',
    component: appDown,
    meta: { breadcrumb: 'App下载' },
    // meta: { requiresAuth: true }
  },
  {
    path: '/aboutUs',
    name: '关于我们',
    component: aboutUs,
    meta: { breadcrumb: '关于我们' },
    // meta: { requiresAuth: true }
  },
  {
    path: '/map',
    name: '地图',
    component: map,
    meta: { breadcrumb: '地图' },
    // meta: { requiresAuth: true }
  },
  {
    path: '/course',
    name: '足球赛程',
    component: course,
    meta: { breadcrumb: '足球赛程' },
    // meta: { requiresAuth: true }
  },
  {
    path: '/mine',
    name: '我的资料',
    component: mine,
    meta: { breadcrumb: '我的资料' },
    // meta: { requiresAuth: true }
  },
  {
    path: '/myExpertDetail',
    name:'专家智选',
    component:()=>import('@/views/expert/myDetail.vue'),
    meta: { breadcrumb: '专家智选'}
  },
  {
    path: '/expertDetail',
    name:'专家详情',
    component:()=>import('@/views/expert/detail.vue'),
    meta: { breadcrumb: '专家详情'}
  },
  {
    path: '/killno',
    name:'杀号详情',
    component:()=>import('@/views/expert/killno.vue'),
    meta: { breadcrumb: '杀号详情'}
  },
  {
    path: '/recommend',
    name:'推荐详情',
    component:()=>import('@/views/expert/recommend.vue'),
    meta: { breadcrumb: '推荐详情'}
  },
  {
    path: '/moreKillno',
    name:'更多杀号',
    component:()=>import('@/views/expert/moreDataList.vue'),
    meta: { breadcrumb: '更多杀号'}
  },
  {
    path: '/moreRecommend',
    name:'更多推荐',
    component:()=>import('@/views/expert/moreDataList.vue'),
    meta: { breadcrumb: '更多推荐'}
  },
  {
    path: '/expertList',
    name:'专家列表',
    component:()=>import('@/views/expert/expertList.vue'),
    meta: { breadcrumb: '专家列表'}
  },
  {
    path: '/writeKillno',
    name:'添加杀号',
    component:()=>import('@/views/expert/writeKillno.vue'),
    meta: { breadcrumb: '添加杀号'}
  },
  {
    path: '/writeRecommend',
    name:'添加杀号',
    component:()=>import('@/views/expert/writeRecommend.vue'),
    meta: { breadcrumb: '添加推荐号'}
  },
  {
    path: '/applyExpert',
    name:'添加杀号',
    component:()=>import('@/views/expert/applyExpert.vue'),
    meta: { breadcrumb: '申请专家'}
  }
]

const router = new Router({
  // mode: 'history',
  mode:'hash',
  base: process.env.BASE_URL,
  routes
});
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('token')
    if (!token) {
      store.commit('TOGGLE_LOGIN_MODAL', true)  // 触发弹窗
      next('/')  // 重定向到首页或其他指定页面
    } else {
      next()  // 已登录，放行
    }
  } else {
    next()  // 不需要认证的路由
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js